import { useCpmsBoGetTransactionReportsCountByThirdPartyEndpointQuery } from '@service/cpms-bo-transaction-reports-count-statistics.service';

import {
  ByThirdPartyEndpointCard,
  ByThirdPartyEndpointCardVariantEnum,
} from '../../components/by-third-party-endpoint-card/by-third-party-endpoint.card';
import { useFilters } from '../../context/filters.context';

export const TransactionsByThirdPartyEndpointCard = (): React.JSX.Element => {
  const { transformedFilters } = useFilters();
  const { data } = useCpmsBoGetTransactionReportsCountByThirdPartyEndpointQuery(
    {
      ...transformedFilters,
    },
  );

  return (
    <ByThirdPartyEndpointCard
      data={data}
      variant={ByThirdPartyEndpointCardVariantEnum.Transactions}
    />
  );
};
